import FetchService from "./Shared/FetchService";
const baseURL = "/aviso/courseSectionSchedulerLocation";
export default class CourseSectionSchedulerLocationService {
    static getLocations() {
        return FetchService.getSingleResponse(baseURL + "/getLocations");
    }
    static addLocation(locationId) {
        return FetchService.postSingleResponse(baseURL + "/addLocation", {
            locationId,
        });
    }
    static removeLocation(locationId) {
        return FetchService.postSingleResponse(baseURL + "/removeLocation", {
            locationId,
        });
    }
}
